import React from "react";
import { motion } from "framer-motion";
import { useEffect } from "react";


export default function EngineeringExplorers() {
  
  const handleWhatsAppRedirect = () => {
    const phoneNumber = "917798283335";
    const message = encodeURIComponent(
      "Hello, I'm interested in joining the Entrepreneurship League!"
    );
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappURL, "_blank");
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const features = [
    {
      color: "bg-pink-600",
      iconBg: "bg-pink-600",
      text: "Love turning your curiosity into real-world health innovations",
      icon: "https://dbqa318yoj3nn.cloudfront.net/IconIdea.png",
    },
    {
      color: "bg-yellow-500",
      iconBg: "bg-yellow-500",
      text: "See global health challenges as chances to create solutions",
      icon: "https://dbqa318yoj3nn.cloudfront.net/IconLightbulb.png",
    },
    {
      color: "bg-blue-600",
      iconBg: "bg-blue-600",
      text: "Believe in blending science, empathy, and innovation to make an impact",
      icon: "https://dbqa318yoj3nn.cloudfront.net/IconPeople.png",
    },
  ];

  return (
    <div className="overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative w-full bg-white overflow-hidden flex flex-col items-center justify-center text-center px-4 py-8 md:py-12">
        {/* Background Elements */}
        <div className="absolute w-32 h-32 sm:w-64 sm:h-64 bg-white rounded-full shadow-2xl top-10 left-4 z-0">
              <img className="hidden lg:block" src="https://dbqa318yoj3nn.cloudfront.net/EEE.png"/>
        </div>
        <div className="absolute w-[200px] h-[200px] sm:w-[550px] sm:h-[550px] bg-white rounded-full shadow-2xl -top-20 -right-20 sm:-top-40 sm:-right-40 z-0"></div>
        <div className="absolute w-12 h-12 sm:w-20 sm:h-20 bg-purple-500 rounded-full blur-2xl right-8 top-20 sm:right-12 sm:top-40 z-0 opacity-70"></div>
        {/* <div className="absolute w-16 h-16 sm:w-28 sm:h-28 bg-white rounded-full shadow-md right-6 top-24 sm:right-10 sm:top-44 z-0"></div> */}
        <div className="absolute w-20 h-40 sm:w-32 sm:h-32 bg-purple-500 rounded-full blur-3xl left-4 bottom-8 sm:bottom-10 opacity-60 z-0"></div>
        <div className="absolute w-12 h-12 sm:w-20 sm:h-20 bg-purple-500 rounded-full blur-2xl right-8 top-20 sm:right-12 sm:top-40 z-0 opacity-70"></div>

        {/* Main Content */}
        <div className="relative z-10 mt-6 sm:mt-10 md:mt-16">
          <h1
            className="text-2xl sm:text-4xl md:text-6xl font-extrabold text-blue-600"
            style={{ fontFamily: "Montserrat" }}
          >
            ENGINEERING
          </h1>
          <div className="mt-2 sm:mt-3">
            <span
              className="text-white bg-pink-400 px-2 py-1 text-xl sm:text-3xl md:text-5xl font-bold rounded"
              style={{ fontFamily: "Montserrat" }}
            >
             EXPLORERS
            </span>
          </div>
          <p
            className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mt-3 sm:mt-5"
            style={{ fontFamily: "Montserrat" }}
          >
            Innovate Today. Engineer Tomorrow
          </p>
          <p
            className="mt-2 sm:mt-4 max-w-md sm:max-w-xl text-xs sm:text-sm md:text-base text-gray-600 mx-auto"
            style={{ fontFamily: "Poppins" }}
          >
           Got a mind for problem-solving and a passion for building the future? This club is for young engineers ready to turn their ideas into real-world solutions. Explore the power of technology, innovation, and creativity to become the engineers of tomorrow. 
          </p>
        </div>

        <h2
          className="mt-8 md:mt-20 text-xl md:text-5xl font-bold text-yellow-500"
          style={{ fontFamily: "Montserrat" }}
        >
          What skills will you build ?
        </h2>
      </section>

      {/* Skills Visualization Section */}
      <section className="relative w-full py-6 bg-white flex flex-col items-center justify-center overflow-hidden">
        <div className="w-full max-w-[600px] px-4">
          <img
             src="https://dbqa318yoj3nn.cloudfront.net/engineeringexplorers.png"
            alt="entrepreneurship"
            className="w-full h-auto object-cover rounded-lg 
                transition-all duration-700 ease-in-out 
                hover:scale-105 hover:shadow-2xl
                animate-fadeIn [animation-fill-mode:both]"
            style={{ maxHeight: "430px" }}
          />
        </div>
      </section>
      {/* Features Section */}
      <section className="bg-gray-100 py-8 md:py-14 px-4 text-center">
        <h2
          className="text-2xl md:text-4xl font-bold text-purple-700 mb-6 md:mb-12"
          style={{ fontFamily: "Montserrat" }}
        >
          This club is for you, if you
        </h2>
        <div className="flex flex-col md:flex-row justify-center items-stretch gap-4 md:gap-6 max-w-6xl mx-auto">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              className={`relative ${feature.color} text-white rounded-2xl md:rounded-[2rem] px-4 py-8 md:px-6 md:py-12 text-center flex-1 shadow-md`}
              whileHover={{ y: -5 }}
              transition={{ duration: 0.2 }}
            >
              <div className="absolute -top-8 md:-top-10 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-1 md:p-2 shadow-md">
                <div
                  className={`${feature.iconBg} rounded-full w-12 h-12 md:w-20 md:h-20 flex items-center justify-center`}
                >
                  <img
                    src={feature.icon}
                    alt="icon"
                    className="w-6 h-6 md:w-10 md:h-10"
                  />
                </div>
              </div>
              <p
                className="mt-8 md:mt-6 text-sm md:text-lg font-semibold leading-relaxed"
                style={{ fontFamily: "Poppins" }}
              >
                {feature.text}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Club Vibe Section */}
      <div className="bg-white py-10 px-4 md:px-10 relative">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-extrabold text-center">
          <span
            className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-500"
            style={{ fontFamily: "Montserrat" }}
          >
            The Engineering Explorers Club Vibe
          </span>
        </h2>

        {/* Main content */}
        <div className="flex flex-col md:flex-row items-center mt-5 md:mt-0 justify-center gap-10 max-w-6xl mx-auto relative z-10">
          {/* Text box with notch - Mobile adjustments */}
          <div className="relative max-w-3xl mx-auto md:mt-[-210px] mt-0 w-full">
            {/* Notch - Hidden on mobile */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 bg-white rotate-45 border-t-2 border-l-2 z-10"></div>
            {/* Content box */}
            <div className="bg-white border shadow-xl rounded-xl p-6 md:p-6 md:w-[600px] space-y-4 md:space-y-6 relative z-0">
              {/* Item 1 */}
              <div className="flex items-start gap-3 md:gap-4">
                <img
                  src="https://dbqa318yoj3nn.cloudfront.net/book.png"
                  alt="Book Icon"
                  className="w-6 h-6 md:w-8 md:h-8"
                />
                <div>
                  <p
                    className="font-bold text-blue-600 text-sm md:text-base"
                    style={{ fontFamily: "Montserrat" }}
                  >
                    Think Innovation Meets Impact
                  </p>
                  <p
                    className="text-gray-800 text-xs md:text-sm"
                    style={{ fontFamily: "Poppins" }}
                  >
                   Use engineering, creativity, and logic to solve real-world challenges and shape the future.
                  </p>
                </div>
              </div>

              {/* Item 2 */}
              <div className="flex items-start gap-3 md:gap-4">
                <img
                  src="https://dbqa318yoj3nn.cloudfront.net/clap.png"
                  alt="Challenge Icon"
                  className="w-6 h-6 md:w-8 md:h-8"
                />
                <div>
                  <p
                    className="font-bold text-blue-600 text-sm md:text-base"
                    style={{ fontFamily: "Montserrat" }}
                  >
                   Collaborate Like a Creator
                  </p>
                  <p
                    className="text-gray-800 text-xs md:text-sm"
                    style={{ fontFamily: "Poppins" }}
                  >
                  Team up with peers to build, test, and improve solutions together.
                  </p>
                </div>
              </div>

              {/* Item 3 */}
              <div className="flex items-start gap-3 md:gap-4">
                <img
                  src="https://dbqa318yoj3nn.cloudfront.net/trophy.png"
                  alt="Build Icon"
                  className="w-6 h-6 md:w-8 md:h-8"
                />
                <div>
                  <p
                    className="font-bold text-blue-600 text-sm md:text-base"
                    style={{ fontFamily: "Montserrat" }}
                  >
                    From Blueprints to Breakthroughs
                  </p>
                  <p
                    className="text-gray-800 text-xs md:text-sm"
                    style={{ fontFamily: "Poppins" }}
                  >
                   Turn everyday ideas into working models through critical thinking and experimentation.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Character image - Mobile adjustments */}
          <div className="w-full md:w-[35%] relative md:-mb-40 mb-0 z-20">
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/charactermen.png"
              alt="Character"
              className="w-full h-auto md:h-[700px] object-contain"
            />
          </div>
        </div>

        {/* CTA section - Mobile adjustments */}
        <div className="md:mt-[-100px] mt-10 pt-10 md:pt-20 bg-gradient-to-r from-purple-500 to-indigo-500 text-white rounded-3xl py-6 md:py-10 px-6 max-w-5xl mx-auto relative z-0">
          <div className="flex flex-col items-center md:items-start text-center md:text-left px-4 md:px-10">
            <h3
              className="text-2xl md:text-5xl w-[60%] leading-tight font-extrabold"
              style={{ fontFamily: "Montserrat" }}
            >
              If This Club Sparks{" "}
              <span
                className="text-yellow-400"
                style={{ fontFamily: "Montserrat" }}
              >
                Your Passion
              </span>
            </h3>
            <button
              onClick={handleWhatsAppRedirect}
              style={{ fontFamily: "Montserrat" }}
              className="mt-4 md:mt-6 bg-white text-orange-500 font-semibold px-4 md:px-6 py-2 md:py-3 rounded-full shadow hover:bg-orange-100 transition text-sm md:text-base"
            >
              Get In Touch →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
